module.exports = __webpack_public_path__ + "img/doc.3fab3f8c.svg";